export const environment = {
  connection: {
    heartbeatInterval: 15000, // Ping a cada 15s
    heartbeatTimeout: 5000, // Timeout de 5s por ping
    maxHeartbeatFailures: 3, // 3 falhas = desconectado
    reconnectBaseDelay: 2000, // Começa com 2s
    reconnectMaxDelay: 30000, // Máximo 30s entre tentativas
    reconnectMultiplier: 2, // Dobra o delay a cada falha
    enableDebugLogs: true, // Logs detalhados em dev
  },
  stage: "dev",
  socketUrl: "https://api-dev.thecoolrhyno.com",
  siteUrl: "https://dev.thecoolrhyno.com",
  backend: "https://api-dev.thecoolrhyno.com/api/v1",
  datadog: {
     enabled: false,
    applicationId: "",
    clientToken: "",
    site: "datadoghq.com",
    service: "streamer-alert-web",
    env: "dev",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    version: "dev",
  },
};
